<template lang="pug">
//---------- VueCLI 原始保留 ----------
  <div class="home">
      <img alt="Vue logo" src="../assets/logo.png">
      <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
//---------- VueCLI 原始保留 ---------- 

#APET_home
  section#picPlay
    swiper(:options="swiperOptions1")
      swiper-slide(v-for="item in picData", v-bind:key="item.id")
        .all_block
          .left_block
            .titleBlock
              .h1_title_group
                h1 {{ item.title1 }}
                h1 {{ item.title2 }}
              p {{ item.text }}
              .btn
                router-link(v-bind:to="item.router_link") {{ item.buttonText }}
          .IMG
            img.desktop(v-bind:src="item.url")
            img.mobile(v-bind:src="item.url_mobile")
          .swiper-pagination(slot="pagination")

    .block2

  div#mobile_product_menu
    b-container
        h1.cardTitle1 {{ windowWidth > 576 ? 'APPLICATION' : 'PRODUCTS' }}
        //- h3.cardTitle2 {{ windowWidth > 576 ? '產品應用類別' : '產品' }}
    b-container.button_Pagination
      .cardChange_Button(
        v-bind:class="{ active: btn.cardDisplay }",
        v-for="btn in card_Button_mobile"
      )
        h3(v-on:click="change_card_Pagination()") {{ btn.title }}
  section#application( v-show="windowWidth > 576 ? true : card_Button_mobile[0].cardDisplay" )
    b-container.wow.fadeInLeft( v-show="windowWidth > 576 ? true : card_Button_mobile[0].cardDisplay" )
      .b_cardGroup(v-for="groups in appData", v-bind:key="groups.id")
        b-row
          b-col(
            v-bind:sm="bootstrap_col_compute(groups.group1.length)",
            v-for="item in groups.group1",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)
        b-row
          b-col(
            v-bind:sm="bootstrap_col_compute(groups.group2.length)",
            v-for="item in groups.group2",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)
        b-row
          b-col(
            v-bind:sm="4",
            v-for="item in groups.group3",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)
          b-col(
            v-bind:sm="8",
            v-for="item in groups.group4",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)

  section#processing( v-show="windowWidth > 576 ? true : card_Button_mobile[1].cardDisplay")
    b-container( v-show="windowWidth > 576 ? true : false" )
      h1.cardTitle1 {{ windowWidth > 576 ? 'PROCESSING' : '' }}
      //- h3.cardTitle2 {{ windowWidth > 576 ? '產品後加工方式' : '' }}
    b-container.wow( v-show="windowWidth > 576 ? true : card_Button_mobile[1].cardDisplay" )
      .b_cardGroup(
        v-for="groups in processingData",
        v-bind:key="groups.id"
      )
        b-row
          b-col(
            v-bind:sm="bootstrap_col_compute(groups.group1.length)",
            v-for="item in groups.group1",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)
        b-row
          b-col(
            v-bind:sm="bootstrap_col_compute(groups.group2.length)",
            v-for="item in groups.group2",
            v-bind:key="item.id"
          )
            router-link(v-bind:to="item.router_link")
              .card
                img.deskTop(v-bind:src="item.img_src")
                img.mobile(v-bind:src="item.img_src_mobile")
                .title_block
                  h4 {{ item.title }}
                    svg(viewbox="0 0 50 30")
                      line(x1=0, y1=20, x2=45, y2=20)
                      line(x1=45, y1=20, x2=31, y2=8)

  section#certification.mb-5.pb-5
    b-container
      h1.cardTitle1 CERTIFICATION
      //- h3.cardTitle2 產品認證
    b-container.cert_block_home
      .img_cert.mb-5.pb-5
        img.wow(src="@/assets/certification.png")
        .textBlock.wow
          h3 NAN YA 
          h1 Environmental-Friendly Plastics
          p Certified in ISO 9001 Quality Management System, ISO 14001 Environmental Management System, OHSAS 18001 Occupational Safety and Health Management System , Taiwan Occupational Safety and Health Management System (TOSHMS) , U.S. FDA certification, and Taiwan Accreditation Foundation(TAF) laboratory accreditation.
          div
            router-link(to="certification").btn_more more
              svg(viewbox="0 0 32 30")
                  line(x1=0 y1=20 x2=30 y2=20)
                  line(x1=30 y1=20 x2=16 y2=8)
</template>

<script>
export default {    
  // name: "Home",
  metaInfo: {
    title: 'NAN YA RIGID FILM-Official website',
    titleTemplate: '',
    meta: [
        { name: 'description', content: 'Nan Ya Plastics was founded on 1958 and started to manufacture rigid PVC film in 1972. Nan Ya has specialized in rigid PVC film division for 50 years, who is the leading manufacturer in innovation and quality consistency.' },
        { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, APET' },
        { name: 'og:title', content: 'NAN YA RIGID FILM-Official website' },
        { name: 'og:type', content: 'website' },
        { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
        { name: 'og:description', content: 'Nan Ya Plastics was founded on 1958 and started to manufacture rigid PVC film in 1972. Nan Ya has specialized in rigid PVC film division for 50 years, who is the leading manufacturer in innovation and quality consistency. ' },
        { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
    ],
  },
  // components: {
    // HelloWorld,
    // vue-breakpoint-component套件要import的部分(保留)
    // VShowAt, VHideAt, VBreakpoint
  // },

  data() {
    return {
      // 紀錄視窗當下寬度
      windowWidth: window.innerWidth,

      // swiper控制
      swiperOptions1: {
        spaceBetween: 30,
        effect: "fade",
        fadeEffect: { crossFade: true }, // 解決淡入淡出重疊問題
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 滑鼠可點擊導覽點點
        },
        // pagination: '.swiper-pagination',,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        paginationClickable: true,
        autoplay: { delay: 5000 }, // 輪播
        speed: 300, // 切換速度
        loop: true,
        slidesPerView: 0,
        centeredSlides: false,
        mousewheel: false,
        grabCursor: true, //移入後手掌形狀
        lazyLoading: false,
        slideShadows: false,
      },

      card_Button_mobile: [
        {
          card: "app",
          cardDisplay: true,
          title: "APPLICATION",
        },
        {
          card: "process",
          cardDisplay: false,
          title: "PROCESSING",
        },
      ],

      picData: [
        {
          id: 5,
          title1: "ANTIBACTERIAL & ANTI-FOG",
          title2: "FOR DOBULE PROTECTION",
          text: "Suit for face-shield using, it not only anti-fog but also antibacterial, double protection to leave virus away.",
          buttonText: "Food and Medical use",
          router_link: "Food-and-medicine",
          url: "./img/picPlay/picPlay_5.jpg",
          url_mobile: "./img/picPlay_mobile/picPlay_m_5.jpg",
        },
        {
          id: 1,
          title1: "NOBILITY",
          title2: "HIGH QUAILITY",
          text: "suitable for the production of decorative materials such as carved doors, curtains, side strips, floor tiles and wood grain panels.",
          buttonText: "Decoration materials",
          router_link: "decoration",
          url: "./img/picPlay/picPlay_1.png",
          url_mobile: "./img/picPlay_mobile/picPlay_m_1.png",
        },
        {
          id: 2,
          title1: "TOXIC FREE",
          title2: "SAFE & HEALTH",
          text: "Foodstuff Packaging film is suitable for packaging of various foods or medicines",
          buttonText: "Food and Medical use",
          router_link: "Food-and-medicine",
          url: "./img/picPlay/picPlay_2.png",
          url_mobile: "./img/picPlay_mobile/picPlay_m_2.jpg",
        },
        {
          id: 3,
          title1: "DUST FREE",
          title2: "ANTI-STASTIC",
          text: "Anti-Static film is suitable for forming as general electronic packaging or industrial packaging materials.",
          buttonText: "Antistatic packaging",
          router_link: "anti_static",
          url: "./img/picPlay/picPlay_3.png",
          url_mobile: "./img/picPlay_mobile/picPlay_m_3.jpg",
        },
        {
          id: 4,
          title1: "EXCELLENT PRINTING",
          title2: "LAMINATION PROPERTY",
          text: "Lamination film is suitable for printing and laminating to make credit cards.",
          buttonText: "Card lamination",
          router_link: "card_Lamination",
          url: "./img/picPlay/picPlay_4.png",
          url_mobile: "./img/picPlay_mobile/picPlay_m_4.jpg",
        },
      ],

      // 圖片都在public裡面，VueCLI 4.3.1
      appData: [
        {
          group1: [
            {
              id: 1,
              title: "Foodstuff Packaging",
              img_src: "./img/application_Desktop/food_medicine_pvc.jpg",
              img_src_mobile: "./img/application_Mobile/app_m_1.png",
              router_link: "Food-and-medicine",
            },
            {
              id: 2,
              title: "Antistatic Packaging",
              img_src: "./img/application_Desktop/2.png",
              img_src_mobile: "./img/application_Mobile/app_m_2.png",
              router_link: "anti_static",
            },
            {
              id: 3,
              title: "Decoration Materials",
              img_src: "./img/application_Desktop/3.png",
              img_src_mobile: "./img/application_Mobile/app_m_3.png",
              router_link: "decoration",
            },
          ],
          group2: [
            {
              id: 4,
              title: "Card Lamination",
              img_src: "./img/application_Desktop/4.png",
              img_src_mobile: "./img/application_Mobile/app_m_4.png",
              router_link: "card_Lamination",
            },
            {
              id: 5,
              title: "For Stationery",
              img_src: "./img/application_Desktop/5.png",
              img_src_mobile: "./img/application_Mobile/app_m_5.png",
              router_link: "office_stationery",
            },
            {
              id: 6,
              title: "Cooling Tower",
              img_src: "./img/application_Desktop/6.png",
              img_src_mobile: "./img/application_Mobile/app_m_6.png",
              router_link: "water_treatment",
            },
          ],
          group3: [
            {
              id: 7,
              title: "C-PET SHEET",
              img_src: "./img/application_Desktop/8.jpg",
              img_src_mobile: "./img/application_Mobile/app_m_8.jpg",
              router_link: "Cpet-sheet",
            },
          ],
          group4: [
            {
              id: 8,
              title: "GREEN APET",
              img_src: "./img/application_Desktop/app_xl_7.jpg",
              img_src_mobile: "./img/application_Mobile/app_m_7.jpg",
              router_link: "green_apet",
            }
          ]
        },
      ],

      processingData: [
        {
          group1: [
            {
              id: 1,
              title: "Vacuum Molding",
              img_src: "./img/processing_Desktop/1.png",
              img_src_mobile: "./img/processing_Mobile/process_m_1.png",
              router_link: "vacuum_forming",
            },
            {
              id: 2,
              title: "Fold Molding",
              img_src: "./img/processing_Desktop/2.png",
              img_src_mobile: "./img/processing_Mobile/process_m_2.png",
              router_link: "folding_forming",
            },
            {
              id: 3,
              title: "Heat Sealing",
              img_src: "./img/processing_Desktop/3.png",
              img_src_mobile: "./img/processing_Mobile/process_m_3.png",
              router_link: "heat_seal",
            },
          ],
          group2: [
            {
              id: 4,
              title: "Printing",
              img_src: "./img/processing_Desktop/4.png",
              img_src_mobile: "./img/processing_Mobile/process_m_4.png",
              router_link: "print",
            },
            {
              id: 5,
              title: "Metalize",
              img_src: "./img/processing_Desktop/5.png",
              img_src_mobile: "./img/processing_Mobile/process_m_5.png",
              router_link: "plating",
            },
          ],
        },
      ],
    };
  },
  methods: {
    change_card_Pagination() {
      let change = this.card_Button_mobile;
      for (let i in change) {
        change[i].cardDisplay = !change[i].cardDisplay;
        console.log(change[i].cardDisplay);
      }
    },
    bootstrap_col_compute: (groups_length) => {
      return Math.round(12 / groups_length);
    },
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
};
</script>

<style lang="sass">
$ThemeColor: #144361
$titleBarColor: #bfdce3
$titleBlockWidth: 220px

@mixin size($w, $h:$w)
    width: $w
    height: $h
@mixin pseudoBlock($w, $h:$w)
    content: ''
    display: block
    +size($w, $h)

// ------RWD裝置尺寸設定------- //
$large_media: 1200px
$big_media: 992px
$medium_media: 768px + 1px
$small_media: 576px

// 特大
@mixin desktop_width()
    @media all and (min-width: $large_media)
        @content
// 大>特大
@mixin desktop_small_width()
    @media all and (min-width: $big_media) and (max-width: $large_media)
        @content
// 中>大
@mixin tablet_width()
    @media all and (min-width: $medium_media) and (max-width: $big_media)
        @content
// 小>中
@mixin tablet_small_width()
    @media all and (min-width: $small_media) and (max-width: $medium_media)
        @content
// 小
@mixin phone_width()
    @media all and (max-width: $small_media)
        @content

// ------RWD裝置尺寸設定------- //

.btn_more 
    background-color: #FFFFFF
    border: 1px solid rgba(128, 186, 219, 1)
    cursor: pointer
    padding: 5px 25px
    line-height: 1.94
    letter-spacing: 0.96px
    border-radius: 8px
    overflow: hidden
    margin-top: 35px
    float: right
    color: rgba(128, 186, 219, 1)
    font-size: 28px
    text-decoration: none
    line-height: 1.5
    &:hover
      text-decoration: none
      background-color: rgba(128, 186, 219, 1)
      color: #FFFFFF
      svg
        stroke: #FFFFFF
    svg
        width: 32px
        height: 30px
        stroke: rgba(128, 186, 219, 1)
        stroke-width: 2px
        stroke-linecap: round
        z-index: 2
        margin-left: 15px

.btn_more:focus 
    outline: none


// body {
//   background: #1f1a25;
//   display: -webkit-box;
//   display: flex;
//   -webkit-box-align: center;
//           align-items: center;
//   -webkit-box-pack: center;
//           justify-content: center;
//   min-height: 100vh;


#topBar, #picPlay, #application, #processing, #certification
    // display: none
#picPlay
    // display: none

//---------------------------------

#picPlay
    $picPlayHeight: 900px
    $picPlayFont: Arial, "Noto Sans", sans-serif,"微軟正黑體"
    $left_desktop: 19%
    $left_mobile: 12.5%

    position: relative
    margin-top: 70px

    @include tablet_width

    @include tablet_small_width

    @include phone_width
        margin-top: 0px
        height: 170vw
    @media all and ( max-width: 420px )
      height: 195vw
    @media all and ( max-width: 320px )
      height: 200vw

    .swiper-container
        position: relative
        height: 750px

        @include tablet_width
        @include tablet_small_width
            height: 650px
        @include phone_width
            height: 170vw
            margin-top: 0
        @media all and ( max-width: 420px )
          height: 195vw
        @media all and ( max-width: 320px )
          height: 200vw

        // 左方區塊向上滑動動畫
        .swiper-slide .left_block, .swiper-slide-active .left_block
            transition: padding-top 1s 0.1s
            padding-top: 50px
        .swiper-slide-active .left_block
            padding-top: 0

        .all_block
            position: relative
            +size(100%)
            max-width: 1920px
            margin: 0 auto

        // 左方區塊
        .left_block
            position: absolute
            left: $left_desktop
            top: 17%
            +size(358px, auto)
            transition: 0.1s

            @media all and (max-width: 1670px)
                left: 8%
            @media all and (max-width: 1060px)
                +size(290px, auto)
            @include desktop_small_width()
                left: 5%
            @include tablet_width()

            @include tablet_small_width

            @include phone_width
                left: $left_mobile
                width: 100% - $left_mobile
                // top: 50%
                top: 105vw
            @media all and (min-width: 1500px)
              left: 160px

            .titleBlock
                position: relative
                +size(100%, auto)
                transition: 0.1s

                @mixin title_block_Setting($_width, $_height, $_font_size, $_letter-spacing,
                $_text-align, $_font-weight:normal)
                    +size($_width,$_height)
                    font-size: $_font_size
                    letter-spacing: $_letter-spacing
                    text-align: $_text-align
                    font-weight: $_font-weight
                    font-family: $picPlayFont
                    color: $ThemeColor

                .h1_title_group
                    @include phone_width
                        display: flex
                        transition: 0.1s
                        flex-flow: wrap
                    h1
                        +title_block_Setting(100%,auto,26px, initial,left)
                        margin-bottom: 10px

                        @include tablet_width
                            font-size: 24px
                        @include tablet_small_width
                            font-size: 24px
                        @include phone_width
                            +title_block_Setting(auto,auto,20px,initial,left,normal)
                            margin-right: 13px
                            margin-bottom: 0
                            transition: 0.1s
                            flex: 100% 0 0
                        @media all and (max-width: 330px)
                            font-size: 20px
                & > p
                    +title_block_Setting(320px,auto,20px,2.90px,left)
                    color: black
                    margin-top: 36px
                    line-height: 1.37

                    @media all and (max-width: 1060px)
                        width: 290px
                    @include tablet_width

                    @include tablet_small_width
                        font-size: 18px
                    @include phone_width
                        width: 98%
                        margin-top: 20px
                        transition: 0.1s
                        font-size: 15px
                        letter-spacing: 2.81px
                        color: rgba(0,0 ,0 ,0.8 )

                .btn
                    +size(auto)
                    position: absolute
                    left: 0
                    top: 130%
                    padding: 0

                    @include desktop_width()
                        transition: 0.1s
                    @include tablet_width
                        transition: 0.1s
                        margin-top: 30px
                    @include tablet_small_width
                        transition: 0.1s
                        margin-top: 30px
                    @include phone_width
                        transition: 0.1s

                    & > a
                        +title_block_Setting(auto,auto,18px,2.28px,left,bold)
                        // margin-top: 100px
                        padding: 10px 15px
                        line-height: 1.2
                        border: 2px solid $ThemeColor
                        border-radius: 30px
                        transition: 0.3s
                        margin-bottom: 0
                        overflow: hidden
                        display: block
                        &:before
                            +pseudoBlock(30%,100%)
                            position: absolute
                            top: 50%
                            left: 50%
                            transform: translate(-50%,-50%)
                            background-color: $ThemeColor
                            border-radius: 30px
                            opacity: 0
                            transition: none
                            z-index: -1

                        &:hover
                            // background-color: $ThemeColor
                            // color: white
                            // box-shadow: 0px 0px 10px 5px rgba(0,0 ,0 ,0.5 )
                            color: white
                            text-decoration: none
                            &:before
                                width: 100%
                                opacity: 1

                        @include phone_width
                            font-size: 16.2px
                            line-height: 1.2
                            letter-spacing: 1.85px
                            // margin-top: 50px
        .IMG
            position: absolute
            // +size(887px,603px)
            +size(auto)
            overflow: hidden
            // right: $left_desktop
            // left: 50%
            right: 0
            bottom: 50%
            transform: translateY(40%)

            @include desktop_small_width
                right: -10%
            @include tablet_width
                right: unset
                left: 45%
            @include tablet_small_width
                right: unset
                left: 50%
            @include phone_width
                // height: $picPlayHeight
                // left: $left_mobile
                // +size(100% - $left_mobile , 374px)
                // margin-left: 0
                // transition: 0.1s
                // bottom: unset
                // transform: unset
                +size(88.50% , 0)
                padding-top: 98%
                margin-left: 0
                transition: 0.1s
                bottom: auto
                transform: none
                right: 0

            // 電腦版圖片(寬/高)比值1.47
            @mixin img_equal_scale($_width)
                +size($_width, floor($_width/1.47))

            img.desktop
                $_standard_img_width: 976px
                +img_equal_scale($_standard_img_width)
                max-width: $_standard_img_width
                max-height: floor($_standard_img_width/1.47)
                display: block
                  

                @media all and (max-width: 1450px)
                    +img_equal_scale(750px)

                @include desktop_small_width()
                    // +img_equal_scale(800px)
                @include tablet_width
                    // width: 92vw
                    // height: 66vw
                @include tablet_small_width
                    // width: 92vw
                    // height: 66vw
                @include phone_width
                    display: none
            @media all and ( min-width: 1500px )
              width: 60%
              height: auto
              img.desktop
                width: 100%
                max-width: 100%
                height: auto
                max-height: 100%

            img.mobile
                +size(336px,374px)
                display: none

                @include phone_width
                    // display: block
                    // transition: 0.1s
                    // +size(88vw, 96.8vw)
                    // position: absolute
                    // top: 100%
                    // transform: translateY(-100%)
                    // min-width: 365px
                    // min-height: 406px
                    display: block
                    transition: 0.1s
                    +size(100%, auto)
                    position: relative
                    top: 0
                    transform: translateY(-100%)

        // 圖片輪播導覽點點群組
        .swiper-pagination-bullet
          opacity: 0.5
        .swiper-pagination-bullet-active
          opacity: 1
        .swiper-pagination-bullets
            width: auto
            left: 160px
            top: 90%
            bottom: unset
            display: flex
            justify-content: center
            align-items: center

            @media all and (max-width: 1670px)
                left: 8%
            @media (min-width: 1500px)
              left: 160px
            @include desktop_small_width()
                left: 5%
            @include tablet_width

            @include tablet_small_width

            @include phone_width
                left: 50%
                transform: translateX(-50%)
                top: unset
                bottom: 3%

            span
                +size(11px)
                margin-right: 20px
                margin-left: 0
                background-color: white
                @include tablet_width
                    // +size(10px)
                @include tablet_small_width
                    // +size(10px)
                @include phone_width
                    +size(10px)

    .block2
        // position: relative
        // .swiper-container
        +size(100%, 45%)
        background-color: rgba(192, 206, 209, 0.59)
        position: absolute
        // top: 100%
        bottom: 0
        z-index: -1

        @include tablet_width
            // height: 55%
        @include tablet_small_width
        @include phone_width
            height: 55%

// 卡片區塊上方標題CSS打包
@mixin card_title_CSS()
    margin-top: 120px
    @include phone_width
        margin-top: 52px
    .cardTitle1
        +size(auto)
        font-size: 36px
        font-weight: normal
        font-family: Georgia
        letter-spacing: 5.97px
        text-align: center
        color: #000000
        position: relative
        margin-bottom: 50px
        @include tablet_width
            font-size: 28px
        @include tablet_small_width
            font-size: 24px
        @include phone_width
            font-size: 20px

        &:after
            +pseudoBlock(100px, 3px)
            background-color: $titleBarColor
            position: absolute
            left: 50%
            transform: translateX(-50%)
            margin-top: 22px
            @include phone_width
                width: 58px

    .cardTitle2
        font-family: 微軟正黑體
        font-size: 28px
        letter-spacing: 7.36px
        text-align: center
        color: #000000
        margin-bottom: 79px
        @include tablet_width
            font-size: 22px
        @include tablet_small_width
            font-size: 20px
        @include phone_width
            font-size: 16px
            margin-bottom: 17px

// 卡片按鈕分頁群組
@mixin card_Mobile_Button
    .button_Pagination
        display: none
        margin-bottom: 20px
        @include phone_width
            display: flex
            justify-content: center
            align-items: center
            padding: 0
            .cardChange_Button.active
                background-color: #5b9ecb
                color: white
                font-weight: bold
                // pointer-events: none
            .cardChange_Button
                $btn_width: 100%
                $btn_height: 42px
                +size($btn_width, $btn_height)
                background-color: white
                color: #5b9ecb
                cursor: pointer
                // display: flex
                // justify-content: center
                // align-items: center
                border: solid 1px #5b9ecb
                border-right: none
                border-left: none
                h3
                    +size($btn_width)
                    font-size: 16px
                    font-weight: bold
                    font-family: 微軟正黑體
                    letter-spacing: 4.21px
                    text-align: center
                    line-height: $btn_height
                    margin: 0
                // &:hover
                //     background-color: #5b9ecb
                //     color: white
                //     h3

// 卡片區塊CSS打包
@mixin cardCSS()
    $card_content_left: 7%
    $card_content_bottom: 17%

    .b_cardGroup
        +size(100%, auto)
        // animation: fadeInUp 1.5s
        // @include phone_width
        //     animation: fadeInLeft 0.5s
        .col-sm-4, .col-sm-6, .col-sm-8, .col-sm-12
            padding: 6.5px

            @include phone_width
                padding: 8px 20px

            .card
                +size(100%)
                overflow: hidden
                cursor: pointer
                z-index: 10
                position: relative
                &:before
                    +pseudoBlock(100%,50%)
                    position: absolute
                    bottom: 0
                    background: linear-gradient(0deg, rgba(black, 0.5 ), rgba(white, 0 ))
                    pointer-events: none
                    z-index: 11

                &:hover
                    & > img.deskTop
                        transform: scale(1.2)
                    &:before
                        opacity: 0
                    svg
                        stroke: darken($titleBarColor, 20px) !important

                & > img.deskTop
                    +size(100%)
                    transition: 0.3s
                    @include phone_width
                        display: none

                & > img.mobile
                    display: none
                    @extend img.deskTop
                    @include phone_width
                        display: block

                // 卡片標題+svg箭頭
                .title_block
                    +size(100%, auto)
                    position: absolute
                    display: flex
                    padding-left: $card_content_left
                    bottom: $card_content_bottom

                    @include tablet_width
                        height: 1.7rem
                    @include tablet_small_width
                        bottom: 19%
                    @include phone_width()
                        padding-left: 4%
                        bottom: 12%

                    h4
                        +size(auto,100%)
                        position: relative
                        margin-bottom: 0
                        text-shadow: 0 2px 3px #071c34
                        font-family: 微軟正黑體
                        font-size: 1.7rem
                        font-weight: bold
                        font-stretch: normal
                        font-style: normal
                        line-height: normal
                        letter-spacing: 1.91px
                        color: #ffffff
                        pointer-events: none
                        z-index: 11

                        @include tablet_width
                            font-size: 1.2rem
                            // top: 60%
                        @include tablet_small_width
                            font-size: 1rem
                            // top: 60%
                        @include phone_width()
                            font-size: 1.2rem
                            left: 0

                    // .arrow
                    //     position: absolute
                    //     +size(60px, 13px)
                    //     top: 86%
                    //     left: 6%
                    //     z-index: 10
                    //     pointer-events: none
                    //     .line1
                    //         +size(100%, 30%)
                    //         background-color: #5b9ecb
                    //         position: absolute
                    //         top: 100%
                    //         transform: translateY(-100%)
                    //         border-radius: 10px 10px 0px 0px
                    //         @include tablet_width
                    //             top: 76%
                    //         @include tablet_small_width
                    //             top: 76%
                    //     .line2
                    //         +size(50%, 30%)
                    //         background-color: #5b9ecb
                    //         position: absolute
                    //         left: 105%
                    //         transform: translateX(-100%) rotate(40deg)
                    //         border-radius: 10px 20px 15px 10px

                    svg
                        +size(50px,30px)
                        position: absolute
                        top: 100%
                        left: -1px
                        stroke: #FFFFFF
                        stroke-width: 3px
                        stroke-linecap: round
                        z-index: 11

                        @include tablet_width()
                            transform: scale(0.8)
                            top: 22px
                            left: -6px
                        @include tablet_small_width()
                            transform: scale(0.5)
                            top: 14px
                            left: -13px
                        @include phone_width()
                            top: initial
                            position: relative
                            height: 26px
                            margin-left: 15px
#mobile_product_menu
  +card_Mobile_Button()
  +card_title_CSS()

#application, #processing
    +cardCSS()
    overflow: hidden
    > div:nth-child(1)
        animation: fadeInUp 1.5s
        @include phone_width
            animation: fadeInLeft 0.5s

#processing
  +card_title_CSS()
  @media (max-width: 576px)
    margin-top: 0
  div:nth-child(1)
    @include phone_width
        animation: fadeInRight 0.5s
//-----------------------------------------------------------------
#certification
    +card_title_CSS()

    .cert_block_home
        display: flex
        padding: 0
        transition: 0.1s

        // RWD預設最大的寬改成1440px
        @media all and (min-width: 1200px)
            max-width: 1440px
        // @mixin 1200px_to_1380px_screen()
        //     @media all and (min-width: $large_media) and (max-width: 1380px)
        //         @content

        .img_cert
            +size(874px, floor(874/1.47)+px)
            position: relative

            @media all and (max-width: 1380px)
                +size(100%,auto)

            img // 圖片(寬/高)比值：1.47
                +size(100%)
                animation: fadeInUp 1s
                @media all and (max-width: 1380px)
                    // +size(716px, floor(716/1.47)+px)
                    +size(874px, floor(874/1.47)+px)
                    display: flex
                @include tablet_width()
                    +size(716px, floor(716/1.47)+px)
                @include tablet_small_width()
                    +size(535px, floor(535/1.47)+px)
                @include phone_width()
                    +size(100%, auto)

            .textBlock
                position: absolute
                left: 89%
                top: 31%
                +size(558px, auto)
                padding: 56px 45px
                box-shadow: 2px 3px 4px 0 rgba(black, 0.5)
                background-color: white
                animation: fadeInUp 2s

                @media all and (max-width: 1380px)
                    left: auto
                    right: 0
                @include tablet_width()
                    left: 50%
                    top: 50%
                    margin-left: -(558px / 2)
                @include tablet_small_width()
                    left: 50%
                    top: 80%
                    width: 480px
                    margin-left: -(480px / 2)
                @include phone_width()
                    width: 87%
                    left: 0
                    top: 85%
                    margin: auto
                    padding: 22px 10px 32px 16px
                    overflow: hidden
                @media all and (max-width: 991px)
                    > div
                      text-align: center
                      a
                        display: inline-block
                        float: none

                @mixin cert_Text_Setting($width, $height, $font_size, $letter-spacing, $line-height:normal)
                    +size($width, $height)
                    font-size: $font_size
                    letter-spacing: $letter-spacing
                    line-height: $line-height
                    font-family: 微軟正黑體
                    text-align: left
                    font-weight: bold
                    font-stretch: normal
                    font-style: normal
                    margin: 0
                h3
                    +cert_Text_Setting(91px,28px,21px,1.25px)
                    color: $ThemeColor
                    @include phone_width()
                        +cert_Text_Setting(91px,28px,21px,1.25px)
                h1
                    +cert_Text_Setting(100%,20px,26px,1.91px, 1.16)
                    color: #5b9ecb
                    margin-top: 23px
                    @include phone_width()
                        +cert_Text_Setting(186px,60px,24px,1.43px, 1.08)
                        margin-top: 16px
                p
                    +cert_Text_Setting(447px,auto,16px,0.96px, 1.94)
                    color: rgba(black, 0.5)
                    margin-top: 44px
                    @include tablet_small_width()
                        width: 363px
                    @include phone_width()
                        +cert_Text_Setting(100%,auto,14px,0.84px, 1.79)
                        margin-top: 27px
                        min-width: 237px

#certification
    @include tablet_width()
        margin-bottom: 375px !important
    @include tablet_small_width()
        margin-bottom: 490px !important
    @include phone_width()
        margin-bottom: 450px !important
</style>
